import {useEffect} from 'react';

interface TProps {
	title?: string;
	children: React.ReactNode;
}

const CardDefault = (props: TProps) => {
	const {title} = props;

	useEffect(() => {
		document.title = title ? title : 'Default Card Example';
	}, [title]);

	return (
		<div className="card mb-4">
			<div className="card-header">{title}</div>
			<div className="card-body">{props.children}</div>
		</div>
	);
};

export default CardDefault;
